import type {z as zod} from "zod";
import type {Result} from "@vesta/error-handling-remix/result";
import {errorResult, dataResult} from "@vesta/error-handling-remix/result";
import {getErrorFromUnknown} from "@vesta/global-common-typescript/utilities/typeValidationUtilities";

// Assumes API returns response in the shape of T, with a status code of 200
export async function robustClientFetch<T>(
    requestUrl: string,
    requestOptions: RequestInit,
    responseValidator: zod.ZodSchema<T>,
): Promise<Result<T>> {
    try {
        const response = await fetch(requestUrl, requestOptions);

        const responseText = await response.text();

        if (response.ok === false) {
            console.log(
                "Error communicating with backend: Status code not in 2xx or 3xx",
            );
            console.log("Response status:", response.status);
            console.log("Response body:", responseText);

            throw new Error("Error communicating with backend!");
        }

        const responseValidatorResult =
            responseValidator.safeParse(responseText);
        if (responseValidatorResult.success === false) {
            console.log(
                "Error communicating with backend: response validation failed",
            );
            console.log("Response status:", response.status);
            console.log("Response body:", responseText);
            console.log("Validation error:", responseValidatorResult.error);

            throw new Error("Error communicating with backend!");
        }
        const responseObject = responseValidatorResult.data;

        return dataResult(responseObject);
    } catch (exception) {
        const error = getErrorFromUnknown(exception);
        return errorResult(error);
    }
}
